export class Validator {

  public static isArray(value: any, minLength = 0): boolean {
    return Array.isArray(value) && value.length >= minLength;
  }

  public static isBoolean(value: any): boolean {
    return typeof value === 'boolean';
  }

  public static isFunction(value: any): boolean {
    return typeof value === 'function';
  }

  public static isInstanceOf(value: any, model: any): boolean {
    try {
      if (value instanceof model) {
        return true;
      }
    } catch (error) {
      return false;
    }
  }

  public static isMatchOf(value: any, declaration: any): boolean {
    if (Validator.isTypeMatch(Validator.isObject, value, declaration)) {
      for (const property in declaration) {
        if (
          !(
            false === declaration.hasOwnProperty(property) || // keine eigenen Properties werden ausgeschlossen
            /^_/.test(property) || // private Properties werden ausgeschlossen
            (value.hasOwnProperty(property) && declaration.hasOwnProperty(property) && Validator.isMatchOf(value[property], declaration[property]))
          )
        ) {
          return false;
        }
      }
      return true;
    } else {
      return (
        Validator.isTypeMatch(Validator.isArray, value, declaration) ||
        Validator.isTypeMatch(Validator.isBoolean, value, declaration) ||
        Validator.isTypeMatch(Validator.isFunction, value, declaration) ||
        Validator.isTypeMatch(Validator.isNumber, value, declaration) ||
        Validator.isTypeMatch(Validator.isString, value, declaration) ||
        /**
         * Das Declaration-Element darf nicht vom Object-Typ sein! Welches nämlich
         * weitere Unterstrukturen haben kann, die bei null und undefined nicht
         * berücksichtigt werden können.
         */
        (Validator.isObject(declaration) === false &&
          (Validator.isNull(value) ||
            Validator.isUndefined(value)))
      );
    }
  }

  public static isNull(value: any): boolean {
    return value === null;
  }

  public static isNumber(value: any): boolean {
    return isNaN(value) === false && typeof value === 'number';
  }

  public static isObject(value: any): boolean {
    return typeof value === 'object' && value !== null && Validator.isArray(value) === false;
  }

  public static isString(value: any, minLength = 0): boolean {
    return typeof value === 'string' && value.length >= minLength;
  }

  public static isTypeMatch(isTypeFunction: (value: any) => any, value: any, declaration: any): boolean {
    return isTypeFunction(value) === true && isTypeFunction(declaration) === true;
  }

  public static isUndefined(value: any): boolean {
    return value === undefined;
  }
}
